import React, { FunctionComponent } from 'react';

import renderModal from '@components/show_page/modals/renderModal';
import { CloseButton, PrimaryButton } from '@components/library/button/index';

import './styles/_download_alert_modal.scss';

interface DownloadAlertModalProps {
  closeModal: () => void;
  downloadAlert: string;
  downloadCallback: () => void;
  resetShowModal: () => void;
}

const DownloadAlertModal: FunctionComponent<DownloadAlertModalProps> = ({
  closeModal,
  downloadAlert,
  downloadCallback,
}) => (
  <div className="modal-content-wrapper download-alert-modal">
    <div className="modal-content-wrapper__header">
      <span className="bff-download icon" aria-hidden="true" />
      <h3 className="modal-title">{bfTranslate("Download Agreement")}</h3>
      <CloseButton onClick={closeModal} />
    </div>
    <div className="modal-content-wrapper__body">
      <p className="download-alert-content bf-scroll-element">
        {downloadAlert}
      </p>
      <div className="button-container">
        <PrimaryButton
          className="agree-and-download-button"
          onClick={(): void => {
            downloadCallback();
            closeModal();
          }}
          size="medium"
        >
          {bfTranslate("Agree and Download")}
        </PrimaryButton>
      </div>
    </div>
  </div>
);

const ModalComponent = renderModal(DownloadAlertModal, 'DownloadAlertModal');
export default ModalComponent;
